import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FinalStep from '../components/FinalStep';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.finalStep || {},
    narrativesList: state.narratives.list,
  };
}

function mapDispatchToProps() {
  return {};
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FinalStep));



// WEBPACK FOOTER //
// ./src/components/Steps/FinalStep/container/index.js